import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toggleWishlist } from "../../../apis/game/wishlist";
import { queryContants } from "../../../constant";

export const useWishlistMutation = (invalidateKeys) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: toggleWishlist,
    onSuccess: () => {
      invalidateKeys?.forEach((key) => queryClient.invalidateQueries(key));      
      queryClient.invalidateQueries(queryContants.GET_WISHLIST)
      queryClient.invalidateQueries(queryContants.GET_GAME)
    },
  });
};